import { Injectable, inject, signal } from "@angular/core";
import { AuthService } from "../../services/auth.service";

@Injectable({ providedIn: 'root' })

export class HomePageService {
  focusedView$ = signal<'none' | 'auctions' | 'codes'>('none');
}
